import React from 'react'
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";

import { setEnabledForm, setViewMode } from "../../redux/actions/genericActions";
import { ButtonNew } from "../buttons/buttonsActions";

const NewItemButton = props => {
    const { viewMode } = props.info

    return(<Row>
        <Col md="12">
            <div className="d-flex align-items-center">
                {
                    viewMode === 'LIST' && <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={() => {
                            props.setViewMode('FORM')
                            props.setEnabledForm(true)
                        } }/>
                    </div>
                }
            </div>
        </Col>
    </Row>)
}

const mapStateToProps = state => ({ info : state.genericInfo })
const mapActionsToProps = ({ setViewMode, setEnabledForm })

export default connect(mapStateToProps, mapActionsToProps)(NewItemButton)